module.exports = __webpack_public_path__ + "img/historia_3-4_768.d4ff840c.jpg";